import React, { useState } from 'react'
import { Collapse } from 'react-collapse'
import { useLangContext } from '../context/lang.context'
import { StoreContext } from '../context/store-context'
import { CartButton } from '../components/shopify/cart-button'
import { Toast } from '../components/shopify/toast'
import { Link } from 'gatsby'
import { alpha, colors, s, sDesktop, sMobile } from '../style'
import Arrow from '../assets/SVGarrow'
import Logo from '../assets/Logo'
import useMenu from '../context/menu.hook'

const Menu = ({ white }) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const { menu } = useMenu()

  const { checkout, loading, didJustAddToCart } = React.useContext(StoreContext)

  const items = checkout ? checkout.lineItems : []

  const quantity = items.reduce((total, item) => {
    return total + item.quantity
  }, 0)

  const path = typeof window !== 'undefined' ? window.location.pathname : ''

  return (
    <>
      <nav css={[ sMenu, white && { color: colors.text }]}>
        <Link
          to='/'
          css={[sLogo, white && menuOpen && { color: 'white' }]}
          name='Omida VLS'>
          <Logo />
        </Link>

        {/* MOBILE */}
        <MenuMobile data={menu} menuOpen={menuOpen} />
        {/* DESKTOP */}
        <div css={sMenuWrapper}>
          <ul css={[sUL, sDesktop]}>
            {menu?.map((menuItem, id) => (
              <LinkMain key={id} data={menuItem} id={id} items={menu.length} />
            ))}
          </ul>
          {/* <div css={sDesktop} /> */}

          <div css={sMenuWrapper}>
            {/* <CartButton quantity={quantity} /> */}
            <button
              name='menu'
              title='Menu'
              aria-label='Menu'
              css={[sMobile, sMenuButton, menuOpen && sMenuButtonActive]}
              onClick={() => setMenuOpen(!menuOpen)}>
              <div className='top'></div>
              <div className='mid'></div>
              <div className='bot'></div>
            </button>
          </div>
        </div>
        <Toast show={loading || didJustAddToCart}>
          {!didJustAddToCart ? (
            'Updating…'
          ) : (
            <>
              Added to cart{' '}
              <svg
                width='14'
                height='14'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M5.019 10.492l-2.322-3.17A.796.796 0 013.91 6.304L6.628 9.14a1.056 1.056 0 11-1.61 1.351z'
                  fill='#fff'
                />
                <path
                  d='M5.209 10.693a1.11 1.11 0 01-.105-1.6l5.394-5.88a.757.757 0 011.159.973l-4.855 6.332a1.11 1.11 0 01-1.593.175z'
                  fill='#fff'
                />
                <path
                  d='M5.331 7.806c.272.326.471.543.815.163.345-.38-.108.96-.108.96l-1.123-.363.416-.76z'
                  fill='#fff'
                />
              </svg>
            </>
          )}
        </Toast>
      </nav>
      <div css={sBackground(white)} />
    </>
  )
}

const MenuMobile = ({ data, menuOpen }) => {
  return (
    <ul
      css={[
        sMenuMobile,

        menuOpen && { pointerEvents: 'auto', opacity: 1 },
        {
          [s.md]: {
            display: 'grid',
            gridAutoRows: 'min-content',
            gridTemplateColumns: '1fr 1fr',
          },
        },
        sMobile,
      ]}>
      {data.map((menuItem, id) => (
        <LinkMobile key={id} data={menuItem} nested={0} />
      ))}
    </ul>
  )
}

const LinkMobile = ({ data, nested }) => {
  const { lang } = useLangContext()
  const [open, setOpen] = useState(false)
  const { name, slug, links, title } = data

  const isNoLinksChild = nested > 1 && !(links?.length > 0)
  return (
    <li
      css={[
        {
          listStyle: 'none',
          margin: '1rem 0',
          [s.sm]: { margin: 0, padding: '1rem 2rem 0 0', flexShrink: 0 },
        },
        nested === 0 && { [s.sm]: { padding: '2rem' } },
      ]}>
      <div
        css={[
          {
            willChange: 'background-color',
            transition: 'background-color 0.2s ease-out',
            display: 'flex',
            alignItems: 'center',
            // padding: '1rem 0 1rem 0rem',

            borderRadius: '1rem',
            marginLeft: 1.5 * nested + 'rem',
            [s.ss]: { marginLeft: 1 * nested + 'rem' },
          },
          open && { backgroundColor: colors.greyDark },
        ]}>
        {links ? (
          <div
            aria-label='expand'
            onClick={() => setOpen(!open)}
            onKeyPress={() => setOpen(!open)}
            tabIndex={0}
            role='button'
            css={[
              sArrowMobile,
              open
                ? { svg: { transform: 'rotate(-90deg)' }, opacity: 1 }
                : { svg: { transform: 'rotate(90deg)' }, opacity: 0.3 },
            ]}>
            <Arrow />
          </div>
        ) : (
          <div
            css={[
              sArrowMobile,
              isNoLinksChild && {
                paddingTop: '0.5rem',
                paddingBottom: '0.5rem',
              },
            ]}>
            <svg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
              <circle cx='10' cy='10' r='2' fill='currentColor' />
            </svg>
          </div>
        )}
        {data.action ? (
          <div
            onClick={data.action}
            onKeyPress={data.action}
            tabIndex={0}
            role='button'
            css={[
              sSublinkMobile,
              nested === 0 && sLinkMobile,
              { padding: '1rem 1rem 1rem 0rem' },
              isNoLinksChild && {
                paddingTop: '0.5rem',
                paddingBottom: '0.5rem',
              },
              links?.length > 0 &&
                !open &&
                nested > 0 &&
                !isNoLinksChild && { opacity: 0.6 },
            ]}>
            {name || lang.toUpperCase()}
          </div>
        ) : (
          <Link
            to={slug}
            css={[
              sSublinkMobile,
              nested === 0 && sLinkMobile,
              { padding: '1rem 1rem 1rem 0rem' },
              isNoLinksChild && {
                paddingTop: '0.5rem',
                paddingBottom: '0.5rem',
                [s.sm]: {
                  fontSize: '0.875rem',
                },
              },
              links?.length > 0 &&
                !open &&
                nested > 0 &&
                !isNoLinksChild && { opacity: 0.6 },
            ]}>
            {title ? title[lang] : name}
          </Link>
        )}
      </div>
      {links && (
        <Collapse isOpened={open}>
          <ul
          // css={{
          //   [s.sm]: { ...sGrid(links.length >= 30 ? 29 : links.length) },
          // }}
          >
            {links.map((menuItem, id) => (
              <LinkMobile key={id} data={menuItem} nested={nested + 1} />
            ))}
          </ul>
        </Collapse>
      )}
    </li>
  )
}

const sArrowMobile = {
  border: 'none',
  appearance: 'none',
  background: 'transparent',
  padding: '1rem 1rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'currentColor',
  svg: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '1.25rem',
    height: '1.25rem',
    transition: 'transform 0.2s ease-out, opacity 0.2s ease-out',
  },
}

const sSublinkMobile = {
  fontSize: '0.75rem',
  width: '100%',
  cursor: 'pointer',
  fontWeight: 700,
  letterSpacing: '-0.05em',
  transition: 'opacity 0.2s ease-out',
  willChange: 'opacity',
  [s.sm]: {
    fontSize: '1rem',
  },
}

const sLinkMobile = {
  fontSize: '1rem',
  [s.sm]: {
    fontSize: '1.5rem',
  },
}

const sMenuMobile = {
  pointerEvents: 'none',
  opacity: 0,
  transition: 'opacity 0.2s ease-out',
  willChange: 'opacity',
  position: 'absolute',
  top: '-1rem',

  left: 0,
  zIndex: 700,
  width: '100vw',
  height: '100vh',
  overflowX: 'hidden',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  background: `linear-gradient(to bottom, ${colors.text}, ${colors.greyDarker})`,
  padding: '6rem 2rem 4rem',
  color: colors.white,
  '::-webkit-scrollbar': {
    width: 0,
  },
  [s.sm]: {
    top: '-2rem',
    padding: '8rem 2rem 4rem',
  },
  [s.md]: {
    padding: '8rem 2rem 4rem 2rem',
  },
}

const sMenuButton = {
  position: 'relative',
  top: 0,
  left: 0,
  zIndex: 1000,
  backgroundColor: 'transparent',
  appearance: 'none',
  outline: 'none',
  cursor: 'pointer',
  transition: 'all 0.2s ease-out',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  color: 'currentColor',
  borderRadius: 24,
  '.top, .mid, .bot': {
    backgroundColor: 'currentColor',
    height: 3,
    borderRadius: 4,
    margin: '2px 0',
    transition: 'inherit',
    width: 24,
    [s.xs]: { width: 20 },
    [s.sm]: { width: 24 },
  },
  marginLeft: '20px'
}

const sMenuButtonActive = {
  color: 'white',
  '.top': {
    transform: 'translate3d(0px, 7px, 0) rotate(-45deg)',
  },
  '.mid': {
    transform: 'scaleX(0.7)',
    opacity: 0,
  },
  '.bot': {
    transform: 'translate3d(0px, -7px, 0) rotate(45deg)',
  },
}

const LinkMain = ({ data, items, id }) => {
  const { lang } = useLangContext()
  const { slug, title, links, button } = data

  return (
    <li
      css={[
        sLinkMain,
        button && (sShopButton),
        !links?.length > 0 && { '.link': { borderRadius: '1rem' } },
      ]}>
      <div css={[sFlexRow, { position: 'relative', top: 0, left: 0 }]}>
        {slug ? (
          <Link to={slug} className='link'>
            {title[lang]}
          </Link>
        ) : (
          <div
            onClick={data.action}
            onKeyPress={data.action}
            className='link'
            tabIndex={0}
            role='button'>
            {lang}
          </div>
        )}
        {links?.length > 0 && (
          <div css={sArrowRotated}>
            <Arrow />
          </div>
        )}
      </div>

      {links?.length > 0 && (
        <ul
          css={[
            sSublinksContainer,
            links.length > 10 ? sGrid(links.length) : sFlex,
          ]}
          className='sublinks'>
          {links.map((linkItem, id) => (
            <LinkChild key={id} data={linkItem} items={links.length} id={id} />
          ))}
        </ul>
      )}
    </li>
  )
}

const LinkChild = ({ data, nested: nestedProp, items, id }) => {
  const [nested] = useState(nestedProp ? nestedProp : 0)
  const { lang } = useLangContext()
  const { slug, title, links, name } = data

  return (
    <li css={sLinkChild(nested)}>
      {slug ? (
        <Link to={slug} className={`sublink${nested}`}>
          {title ? title[lang] : name}
        </Link>
      ) : (
        <div
          className={`sublink${nested}`}
          onClick={data.action}
          onKeyPress={data.action}
          tabIndex={0}
          role='button'>
          {name}
        </div>
      )}
      {links && links.length > 0 && (
        <div css={sArrow}>
          <Arrow />
        </div>
      )}

      {links && (
        <ul
          css={[
            sSublinksContainerLeft,
            links.length > 16 ? sGrid(links.length) : sFlex,
            slug.includes('oferty-pracy') && {
              gridTemplateColumns: '1fr 1fr 1fr 1fr',
            },
            id >= items / 2 && id > 6 && sSublinksContainerBottom,
            { zIndex: 10 + nested },
            id === 0 && { borderRadius: '1rem' },
            data.left && {
              left: 'auto',
              right: '100%',
              borderRadius: '1rem 0 1rem 1rem',
            },
          ]}
          className={`sublinks${nested}`}>
          {links.map((linkItem, id) => (
            <LinkChild
              key={id}
              data={linkItem}
              nested={nested + 1}
              items={links.length}
              id={id}
            />
          ))}
        </ul>
      )}
    </li>
  )
}

const sSublink = {
  transition: 'background-color 0.2s ease-out, color 0.2s ease-out',
  willChange: 'background-color',
  whiteSpace: 'nowrap',
  fontSize: '0.8125rem',
  padding: '0.75rem 2rem',
  width: '100%',
  cursor: 'pointer',
}

const sLinkChild = (nested) => {
  const style = {
    listStyle: 'none',
    display: 'flex',
    position: 'relative',
    top: 0,
    left: 0,

    '.sublink0, .sublink1, .sublink2': { ...sSublink },
  }

  const hover0 = {
    '.sublink0': { backgroundColor: colors.greyLight },
    '.sublinks0': { opacity: 1, pointerEvents: 'auto' },
  }

  const hover1 = {
    '.sublink1': { backgroundColor: colors.greyLight },
    '.sublinks1': { opacity: 1, pointerEvents: 'auto' },
  }

  const hover2 = {
    '.sublink2': { backgroundColor: colors.greyLight },
    '.sublinks2': { opacity: 1, pointerEvents: 'auto' },
  }

  switch (nested) {
    case 0: {
      return { ...style, '&:hover': { ...hover0 } }
    }
    case 1: {
      return { ...style, '&:hover': { ...hover1 } }
    }
    case 2: {
      return { ...style, '&:hover': { ...hover2 } }
    }
    default:
      return { ...style, '&:hover': { ...hover0 } }
  }
}

const sLinkMain = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  top: 0,
  left: 0,
  fontWeight: 700,
  letterSpacing: '-0.05em',
  fontSize: '1rem',
  listStyle: 'none',

  '.link': {
    borderRadius: '1rem 1rem 0 0',
    transition:
      'background-color 0.2s ease-out, color 0.2s ease-out, box-shadow 0.2s ease-out',
    willChange: 'color, background-color, box-shadow',
    padding: '1.5rem 2rem',
    backgroundColor: colors.white.concat(alpha[0]),
    textTransform: 'uppercase',
    fontSize: '0.75rem',
    letterSpacing: '0.05em',
    cursor: 'pointer',
    // wordWrap: 'nowrap',
    whiteSpace: 'nowrap',
  },

  '&:hover': {
    '.link': {
      backgroundColor: colors.white,
      color: colors.text,
      boxShadow: `4px 3px 16px ${colors.text.concat(alpha[16])}`,
    },
    '.sublinks': {
      opacity: 1,
      pointerEvents: 'auto',
    },
  },
}

const sSublinksContainer = {
  transition: 'opacity 0.2s ease-out',
  opacity: 0,
  pointerEvents: 'none',
  position: 'absolute',
  top: '100%',
  left: 0,
  backgroundColor: 'white',
  color: colors.text,
  borderRadius: '0 1rem 1rem 1rem',
  padding: '1rem 0',
  boxShadow: `4px 3px 16px ${colors.text.concat(alpha[16])}`,
}

const sSublinksContainerLeft = {
  ...sSublinksContainer,
  // padding: 0,
  transition: 'opacity 0s',
  left: '100%',
  top: -16,
  borderRadius: '0 1rem 1rem 1rem',
}

const sSublinksContainerBottom = {
  top: 'auto',
  bottom: -16,
  borderRadius: '1rem 1rem 1rem 0',
}

const sUL = {
  display: 'flex',
  position: 'relative',
  top: 0,
  left: 0,
  zIndex: 1000,
}

const sMenu = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  color: 'white',
  zIndex: 1000,
  padding: '0 2rem',
  height: '4rem',
  [s.xs]: {
    marginTop: '1rem',
  },
  [s.sm]: {
    marginTop: '2rem',
  },
  [s.md]: {
    padding: '0 4rem',
  },
  [s.lg]: {
    width: '100%',
    maxWidth: 1500,
    left: '50%',
    transform: 'translateX(-50%)',
  },
}

const sFlex = {
  display: 'flex',
  flexDirection: 'column',
}

const sFlexRow = {
  display: 'flex',
  flexDirection: 'row',
}

const sGrid = (items) => ({
  display: 'grid',
  gridTemplateColumns: items >= 30 ? '1fr 1fr 1fr' : '1fr 1fr',
})

const sBackground = (white) => ({
  pointerEvents: 'none',
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: 3 * 4 + 'rem',
  [s.xs]: { height: 2.5 * 4 + 'rem' },
  [s.ss]: { height: 2 * 4 + 'rem' },
  [s.md]: {
    top: '-2rem',
    height: 4 * 4 + 'rem',
  },
  zIndex: 900,
  background: white
    ? `linear-gradient(to bottom, 
    ${colors.white.concat(alpha[100])}, 
    ${colors.white.concat(alpha[80])},
    ${colors.white.concat(alpha[60])},
    ${colors.white.concat(alpha[30])},
    ${colors.white.concat(alpha[16])},
    ${colors.white.concat(alpha[0])})`
    : `linear-gradient(to bottom, 
    ${colors.text.concat(alpha[100])}, 
    ${colors.text.concat(alpha[60])},
    ${colors.text.concat(alpha[30])},
    ${colors.text.concat(alpha[16])},
    ${colors.text.concat(alpha[8])},
    ${colors.text.concat(alpha[0])})`,
})

const sArrow = {
  width: '1rem',
  height: '1rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  top: '50%',
  right: 0,
  transform: 'translateY(-50%)',
  marginRight: '0.5rem',
  svg: {
    width: '1rem',
    height: '1rem',
  },
}

const sArrowRotated = {
  ...sArrow,
  transform: 'translateY(-50%) rotate(90deg)',
  color: 'currentColor',
}

const sLogo = {
  transition: 'color 0.2s ease-out',
  display: 'flex',
  position: 'relative',
  top: 0,
  left: 0,
  zIndex: 1000,
  width: 150,
  svg: {
    width: 'max-content',
    display: 'flex',
    height: 36,
  },
}

const sShopButton = {
  '.link': {
    background: `linear-gradient(to bottom right, ${colors.brandDark}, ${colors.brandLight})`,
    color: '#fff',
    boxShadow: `0 0 32px #2B2A294D`,
    transition: 'all 0.2s ease-out',
    animation: 'menu-button 2s ease-out infinite both alternate',
  },

  '&:hover': {
    '.link': {
      background: `linear-gradient(to bottom right, ${colors.brandDark}, ${colors.brandLight})`,
      color: '#fff',
    }
  },
}

const sMenuWrapper = {
  display: 'flex',
  alignItems: 'center'
}

export default Menu
